import { StyledRadioButton } from './StyledRadioButton'

interface IProps {
  id: string
  value: string | number
  name?: string
  label?: string
  checked: boolean
  disabled?: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const CustomRadioButton = ({ id, value, label, name, checked, disabled, onChange }: IProps) => {
  return (
    <StyledRadioButton>
      <span className="margin-right">{label}</span>
      <label className="custom-radio">
        <input
          disabled={disabled}
          type="radio"
          id={id}
          value={value}
          name={name}
          checked={checked}
          onChange={onChange}
        />
        <span className="checkmark"></span>
      </label>
    </StyledRadioButton>
  )
}
